<template>
    <div class="gw-main" :style="currentBgStyle">
        <video
            v-if="navList[currentPage].key === 'sy'"
            class="main-bg-video"
            autoplay
            loop
            muted
            playsinline
            src="https://video.eternaldragoon.com/jpsh/bg.mp4"
        ></video>
        <div v-if="navList[currentPage].key !== 'sy'" class="gw-main-header">
            <!-- 左侧logo -->
            <img class="main-logo" :src="require('@/assets/gw-main/gw-ts/logo.png')" alt="logo" />
            <!-- 中间导航菜单 -->
            <ul class="gw-main-nav">
                <li v-for="(item, idx) in navList" :key="item.key" :class="{ active: idx === currentPage }"
                    @click="onNavClick(idx)">{{ item.label }}</li>
            </ul>
            <!-- 右侧社交图标盒子 -->
            <div class="main-socials">
                <img class="social-icon" :src="require('@/assets/gw-main/gw-ts/tw.png')" alt="tw" @click="toUrl('https://x.com/eternaldragoon_')" />
                <img class="social-icon" :src="require('@/assets/gw-main/gw-ts/discord.png')" alt="discord" @click="toUrl('https://discord.gg/WTyyWx9xAP')" />
                <img class="social-icon" :src="require('@/assets/gw-main/gw-ts/youtube.png')" alt="youtube" @click="toUrl('https://www.youtube.com/@eternaldragoon')" />
            </div>
        </div>
        <!-- 固定gift图片，nws页面不显示 -->
        <img v-if="navList[currentPage].key" @click="toUrl('/pay')"  class="fixed-gift" :src="require('@/assets/gw-main/gw-sy/gift.png')" alt="gift" />
        <!-- sy页面视频弹窗和遮罩 -->
        <div v-if="navList[currentPage].key === 'sy' && showVideoModal" class="video-modal-mask" @click.self="closeVideoModal">
            <div class="video-modal">
                <img class="video-modal-close" :src="require('@/assets/gw-main/gw-sy/close.png')" alt="close" @click="closeVideoModal" />
                <video class="video-modal-content" controls autoplay muted src="https://video.eternaldragoon.com/jpsh/gwhome.mp4"></video>
            </div>
        </div>
        <div class="gw-main-bg">
            <div class="swiper-container" ref="swiperContainer">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item) in navList" :key="item.key">
                        <!-- 首页视频 -->
                        <div v-if="item.key === 'sy'" class="sy-page gw-main-page">
                            <video autoplay loop muted playsinline
                                src="https://video.eternaldragoon.com/jpsh/bg.mp4"></video>
                            <!-- sy左上角logo -->
                            <img class="sy-logo" :src="require('@/assets/gw-main/gw-sy/logo.png')" alt="sy-logo" />
                            <!-- sy中间图片1 -->
                            <img class="sy-t" :src="require('@/assets/gw-main/gw-sy/t.png')" alt="sy-t" />
                            <!-- sy中间图片2（播放按钮） -->
                            <img class="sy-bofang" :src="require('@/assets/gw-main/gw-sy/bofang.png')" alt="sy-bofang" @click="openVideoModal" />
                            <!-- sy下方三张图片 -->
                            <div class="aaa">
                                <a href="https://apps.apple.com/app/id6744795814" target="_blank" rel="noopener noreferrer">
                                    <img class="sy-ios-yy" :src="require('@/assets/gw-main/gw-sy/ios-xz.png')" alt="ios-yy" />
                                </a>
                                <a href="https://play.google.com/store/apps/details?id=com.jpeg.gp" target="_blank" rel="noopener noreferrer">
                                    <img class="sy-gp-yy" :src="require('@/assets/gw-main/gw-sy/gp-xz.png')" alt="gp-yy" />
                                </a>
                                <a href="https://download.eternaldragoon.com/apk/eternaldragoon.apk" target="_blank" rel="noopener noreferrer">
                                    <img class="sy-apk-yy" :src="require('@/assets/gw-main/gw-sy/apk.png')" alt="apk-yy" />
                                </a>
                            </div>
                            <img class="sy-jiantou" :src="require('@/assets/gw-main/gw-sy/jiantou.png')" alt="jiantou" />
                            <!-- <div class="sy-content">首页内容</div> -->
                        </div>
                        <!-- 其他页面背景图片 -->
                        <div v-else-if="item.key !== 'external'" :class="item.key + '-page gw-main-page'"
                            :style="{ backgroundImage: 'url(' + getBgImg(item.key) + ')' }">
                            <template v-if="item.key === 'gg'">
                                <!-- 公告页面内容 -->
                                <div class="gg-kuang-news">
                                    <img class="gg-kuang-news-img" :src="require('@/assets/gw-main/gw-gg/kuang-news.png')" alt="kuang-news" />
                                    <img class="gg-news-img" :src="require('@/assets/gw-main/gw-gg/new.png')" alt="news" />
                                </div>
                                <img class="gg-look-img" :src="require('@/assets/gw-main/gw-gg/look.png')" alt="look" />
                                <div class="gg-kuang-x">
                                    <!-- <img class="gg-kuang-x-img" :src="require('@/assets/gw-main/gw-gg/kuang-x.png')" alt="kuang-x" /> -->
                                    <div class="gg-x-embed" ref="twitterContainer">
                                        <blockquote class="twitter-tweet" data-lang="ja"><p lang="ja" dir="ltr">🎊<a href="https://twitter.com/hashtag/%E3%82%A8%E3%82%BF%E3%83%BC%E3%83%8A%E3%83%AB%E3%83%89%E3%83%A9%E3%82%B0%E3%83%BC%E3%83%B3?src=hash&amp;ref_src=twsrc%5Etfw">#エターナルドラグーン</a> 事前ダウンロード開始✨<br>🔗今すぐダウンロード：<a href="https://t.co/SJynkp1UmY">https://t.co/SJynkp1UmY</a><br>明日の朝10時よりサーバー開放！<br><br>事前ダウンロードを記念して、豪華賞品イベント実施中💥<br>🎁<a href="https://twitter.com/hashtag/Amazon%E3%82%AE%E3%83%95%E3%83%88%E3%82%AB%E3%83%BC%E3%83%89?src=hash&amp;ref_src=twsrc%5Etfw">#Amazonギフトカード</a> 5,000円分 X 5名様 <br>🎁<a href="https://twitter.com/hashtag/Amazon%E3%82%AE%E3%83%95%E3%83%88%E3%82%AB%E3%83%BC%E3%83%89?src=hash&amp;ref_src=twsrc%5Etfw">#Amazonギフトカード</a> 1,000円分 X 10名様<br><br>✅応募方法<br>1️⃣… <a href="https://t.co/eK1bNISxbX">pic.twitter.com/eK1bNISxbX</a></p>&mdash; 【公式】エターナルドラグーン：焔の誓い (@eternaldragoon_) <a href="https://twitter.com/eternaldragoon_/status/1950078586347549097?ref_src=twsrc%5Etfw">2025年7月29日</a></blockquote>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="item.key === 'ts'">
                                <!-- ts页面轮播图内容 -->
                                <div class="ts-slider">
                                    <div class="ts-slider-frame">
                                        <img class="ts-slider-img" :src="require(`@/assets/gw-main/gw-ts/${tsCurrentIndex + 1}.png`)" alt="轮播图" />
                                        <!-- 指示器底图 -->
                                        <img class="ts-slider-indicator-bg" :src="require('@/assets/gw-main/gw-ts/lunbo-0.png')" alt="指示器" />
                                        <!-- 指示点 -->
                                        <img v-for="(item, idx) in 7" :key="idx" class="ts-slider-indicator-dot"
                                            v-show="tsCurrentIndex === idx"
                                            :src="require('@/assets/gw-main/gw-ts/lunbo-1.png')"
                                            :style="{ left: `${8.8 + idx * 2.61}vw` }"
                                            @click="goToSlide(idx)"
                                            alt="当前指示" />
                                        <!-- 点击区域（透明按钮） -->
                                        <div v-for="(item, idx) in 7" :key="'btn-' + idx" class="ts-slider-indicator-btn"
                                            :style="{ left: `${8.8 + idx * 2.61}vw` }" @click="goToSlide(idx)"></div>
                                    </div>
                                </div>
                                <!-- ts页面页脚 -->
                                <div class="ts-foot">
                                    <a class="ts-foot-link ts-foot-link-1" href="https://www.eternaldragoon.com/ios-privacy-policy.html" target="_blank" rel="noopener noreferrer"></a>
                                    <a class="ts-foot-link ts-foot-link-2" href="https://www.eternaldragoon.com/ios-user-agreement.html" target="_blank" rel="noopener noreferrer"></a>
                                    <a class="ts-foot-link ts-foot-link-3" href="https://www.eternaldragoon.com/ios-specified-commercial-transaction-law.html" target="_blank" rel="noopener noreferrer"></a>
                                    <a class="ts-foot-link ts-foot-link-4" href="https://www.eternaldragoon.com/ios-fund-settlement-method.html" target="_blank" rel="noopener noreferrer"></a>
                                    <a class="ts-foot-link ts-foot-link-5" href="mailto:htkh.cskh@gmail.com" target="_blank" rel="noopener noreferrer">htkh.cskh@gmail.com</a>
                                </div>
                            </template>
                            <template v-else-if="item.key === 'nws'">
                                <!-- nws页面人物介绍内容 -->
                                <!-- 主要信息图片 -->
                                <div class="nws-information-container">
                                    <transition :name="nwsIsFirstEnter ? 'fade-in-only' : 'fade-in-right'" mode="out-in">
                                        <img
                                            :key="nwsTransitionKey"
                                            class="nws-information-img"
                                            :src="require(`@/assets/gw-main/gw-nws/information-${nwsCurrentIndex + 1}.png`)"
                                            :alt="`information-${nwsCurrentIndex + 1}`"
                                        />
                                    </transition>
                                </div>

                                <!-- 底部图标选择器 -->
                                <div class="nws-icons-container">
                                    <!-- 底部背景图 -->
                                    <img class="nws-icons-bg" :src="require('@/assets/gw-main/gw-nws/icons-0.png')" alt="icons-bg" />

                                    <!-- 选择按钮 -->
                                    <div
                                        v-for="(_, index) in 6"
                                        :key="index"
                                        :class="['nws-choose-btn', { 'active': index === nwsCurrentIndex }]"
                                        @click="selectCharacter(index)"
                                    >
                                        <img
                                            :src="require(`@/assets/gw-main/gw-nws/choose-${index + 1}.png`)"
                                            :alt="`choose-${index + 1}`"
                                        />
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="item.key === 'zy'">
                                <!-- zy页面阵营选择内容 -->

                                <!-- 主要角色图片 -->
                                <div class="zy-main-character"
                                     v-if="getCharacterImage()"
                                     :class="{ 'animating': isZyCharacterAnimating }"
                                     :key="`character-${zyCurrentCharacter}-${zyCurrentForm}-${zyAnimationKey}`">
                                    <img
                                        :src="getCharacterImage()"
                                        :alt="`${zyCurrentCharacter}-${zyCurrentForm}`"
                                        class="zy-character-img"
                                    />
                                </div>

                                <!-- 角色选择框 -->
                                <div class="zy-kuang-container"
                                     :class="{ 'video-playing': isZyVideoPlaying, 'animating': isZyAnimating }"
                                     :key="`kuang-${zyCurrentCharacter}-${zyAnimationKey}`"
                                     v-show="!showZyCharacterInfo">

                                    <!-- 角色展示视频 -->
                                    <div class="zy-character-video-wrapper" @click="showCharacterInfo">
                                        <video
                                            class="zy-character-video"
                                            :src="getCurrentCharacterVideo()"
                                            autoplay
                                            loop
                                            muted
                                            playsinline
                                            preload="auto"
                                            disablePictureInPicture
                                            :key="zyCurrentCharacter"
                                            @loadstart="onZyVideoLoadStart"
                                            @canplay="onZyVideoCanPlay"
                                            @playing="onZyVideoPlaying"
                                            @pause="onZyVideoPause"
                                            @ended="onZyVideoEnded"
                                        ></video>
                                    </div>
                                </div>

                                <!-- 角色介绍弹窗 -->
                                <div v-if="showZyCharacterInfo" class="zy-character-info-modal"
                                     :key="`info-${zyCurrentCharacter}-${zyAnimationKey}`">
                                    <!-- kuang背景 -->
                                    <img class="zy-info-kuang" :src="require('@/assets/gw-main/gw-zy/kuang.png')" alt="kuang" />

                                    <!-- 角色介绍图片 -->
                                    <div class="zy-character-description">
                                        <img
                                            :src="require(`@/assets/gw-main/gw-zy/${zyCurrentCharacter}.png`)"
                                            :alt="`${zyCurrentCharacter}-description`"
                                        />
                                    </div>

                                    <!-- 关闭按钮 -->
                                    <div class="zy-info-close" @click="hideCharacterInfo">
                                        <img :src="require('@/assets/gw-main/gw-zy/close.png')" alt="close" />
                                    </div>
                                </div>

                                <!-- 角色信息区域 - 独立位置，不跟随滑动 -->
                                <div class="zy-character-info">
                                    <!-- 角色标题图片 -->
                                    <div class="zy-character-title" @click="showCharacterInfo">
                                        <img
                                            :src="require(`@/assets/gw-main/gw-zy/${zyCurrentCharacter}-t.png`)"
                                            :alt="`${zyCurrentCharacter}-title`"
                                        />
                                    </div>

                                    <!-- 人族/魔族选择按钮 -->
                                    <div class="zy-form-buttons">
                                        <!-- 人族按钮 -->
                                        <div class="zy-form-btn zy-ren-btn" @click="selectForm('ren')">
                                            <img :src="require('@/assets/gw-main/gw-zy/ren-0.png')" alt="ren-0" />
                                            <img
                                                v-if="zyCurrentForm === 'ren'"
                                                class="zy-form-active"
                                                :src="require('@/assets/gw-main/gw-zy/ren-1.png')"
                                                alt="ren-1"
                                            />
                                        </div>

                                        <!-- 魔族按钮 / 敬请期待按钮 -->
                                        <div class="zy-form-btn zy-mo-btn" @click="selectForm('mo')">
                                            <!-- 如果角色有魔族形态，显示mo-0按钮 -->
                                            <template v-if="zyCurrentCharacter !== 'longqishi' && zyCurrentCharacter !== 'youxia'">
                                                <img :src="require('@/assets/gw-main/gw-zy/mo-0.png')" alt="mo-0" />
                                                <img
                                                    v-if="zyCurrentForm === 'mo'"
                                                    class="zy-form-active"
                                                    :src="require('@/assets/gw-main/gw-zy/mo-1.png')"
                                                    alt="mo-1"
                                                />
                                            </template>
                                            <!-- 如果角色没有魔族形态，显示敬请期待按钮 -->
                                            <template v-else>
                                                <img :src="require('@/assets/gw-main/gw-zy/jinrigongkai-0.png')" alt="jinrigongkai-0" />
                                            </template>
                                        </div>
                                    </div>
                                </div>

                                <!-- 底部角色选择图标 -->
                                <div class="zy-icons-container">
                                    <!-- 底部背景图 -->
                                    <img class="zy-icons-bg" :src="require('@/assets/gw-main/gw-zy/icon-0.png')" alt="icon-0" />

                                    <!-- 角色选择按钮 -->
                                    <div
                                        v-for="character in zyCharacterList"
                                        :key="character"
                                        :class="['zy-character-btn', { 'active': character === zyCurrentCharacter }]"
                                        @click="selectZyCharacter(character)"
                                    >
                                        <img
                                            :src="require(`@/assets/gw-main/gw-zy/${character}-1.png`)"
                                            :alt="`${character}-1`"
                                        />
                                    </div>
                                </div>

                                <!-- zy页面底部图片 -->
                                <div class="zy-bottom-image">
                                    <img :src="require('@/assets/gw-main/gw-zy/db.png')" alt="bottom" />
                                </div>
                            </template>
                            <template v-else>
                                {{ item.label }}内容
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';


export default {
    name: 'gw-main',
    data() {
        return {
            currentPage: 0,
            navList: [
                { key: 'sy', label: 'トップ' },
                { key: 'zy', label: 'キャラクター' },
                { key: 'nws', label: '戦乙女' },
                { key: 'gg', label: 'お知らせ' },
                { key: 'ts', label: 'ゲーム特徴' },
                { key: 'external', label: 'ウェブショップ', url: '/pay' },
            ],
            swiper: null,
            isScrolling: false,
            showVideoModal: false,
            // 新增ts页面轮播图相关数据
            tsCurrentIndex: 0,
            tsTimer: null,
            // 新增nws页面人物介绍相关数据
            nwsCurrentIndex: 0, // 当前选中的角色索引（0-5）
            nwsTransitionKey: 0, // 用于强制触发transition的key
            nwsIsFirstEnter: true, // 标记是否是首次进入nws页面
            // 新增zy页面阵营选择相关数据
            zyCurrentCharacter: 'longqishi', // 当前选中的角色（longqishi, qishi, fashi, yemanren, zhanxingshi, youxia）
            zyCurrentForm: 'ren', // 当前选中的形态（ren, mo）
            zyCharacterList: ['longqishi', 'qishi', 'fashi', 'yemanren', 'zhanxingshi', 'youxia'], // 角色列表
            isZyVideoPlaying: false, // zy页面视频播放状态
            isZyAnimating: false, // zy页面是否正在执行切换动画
            zyAnimationKey: 0, // 用于强制重新触发动画的key
            showZyCharacterInfo: false, // 是否显示角色介绍
            isZyCharacterAnimating: false, // 人物图片是否正在动画中
            isZyInfoAnimating: false, // 介绍是否正在动画中
        };
    },
    watch: {
        currentPage(newVal) {
            // 当切换到nws页面时，强制触发transition
            if (this.navList[newVal].key === 'nws') {
                this.nwsIsFirstEnter = true; // 标记为首次进入
                this.nwsTransitionKey++;
            }
            // 当切换到gg页面时，重新初始化Twitter小部件
            if (this.navList[newVal].key === 'gg') {
                this.$nextTick(() => {
                    this.initTwitterWidget();
                });
            }
        }
    },
    computed: {
        currentBgStyle() {
            // 首页用视频不需要背景图
            if (this.navList[this.currentPage].key === 'sy') {
                return {};
            }
            // 外链页面无背景
            if (this.navList[this.currentPage].key === 'external') {
                return {};
            }
            // 其他页面
            return {
                backgroundImage: `url(${require('@/assets/gw-main/gw-' + this.navList[this.currentPage].key + '/bg.jpg')})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            };
        }
    },
    methods: {
        toUrl(url) {
      window.open(url, '_blank');
    },
        getBgImg(key) {
            // 外链页面没有背景图
            if (key === 'external') return '';
            return require(`@/assets/gw-main/gw-${key}/bg.jpg`);
        },
        onNavClick(idx) {
            const navItem = this.navList[idx];
            // 如果是外链，直接打开新窗口
            if (navItem.key === 'external' && navItem.url) {
                window.open(navItem.url, '_blank');
                return;
            }
            // 只有非外链页面才能滑动
            this.currentPage = idx;
            this.swiper.slideTo(idx);
        },
        // nws页面角色选择方法
        selectCharacter(index) {
            this.nwsCurrentIndex = index;
            this.nwsIsFirstEnter = false; // 不再是首次进入
            this.nwsTransitionKey++; // 强制触发transition
        },
        // zy页面角色选择方法
        selectZyCharacter(character) {
            // 如果正在动画中或选择的是当前角色，不执行切换
            if (this.isZyAnimating || this.isZyCharacterAnimating || character === this.zyCurrentCharacter) {
                return;
            }

            // 判断当前是否在显示介绍状态
            const wasShowingInfo = this.showZyCharacterInfo;

            // 开始人物和视频/介绍的滑出动画
            this.isZyCharacterAnimating = true;
            this.isZyAnimating = true;
            this.isZyVideoPlaying = false;

            if (wasShowingInfo) {
                // 如果当前显示介绍，隐藏介绍
                this.showZyCharacterInfo = false;
            }

            // 延迟切换角色，让滑出动画完成
            setTimeout(() => {
                // 切换角色数据
                this.zyCurrentCharacter = character;
                // 如果选择的角色没有魔族形态，自动切换到人族
                if ((character === 'longqishi' || character === 'youxia') && this.zyCurrentForm === 'mo') {
                    this.zyCurrentForm = 'ren';
                }

                // 立即更新key，触发重新渲染和滑入动画
                this.zyAnimationKey++;

                // 重置动画状态，开始滑入
                this.$nextTick(() => {
                    this.isZyCharacterAnimating = false;
                    this.isZyAnimating = false;

                    if (wasShowingInfo) {
                        // 如果之前显示介绍，切换后也显示新角色的介绍
                        setTimeout(() => {
                            this.showZyCharacterInfo = true;
                        }, 200); // 等待滑入动画开始后再显示介绍
                    } else {
                        // 如果之前显示视频，切换后也显示视频
                        this.isZyVideoPlaying = true;
                    }
                });
            }, 500); // 等待滑出动画完成
        },
        // zy页面形态选择方法
        selectForm(form) {
            // 如果当前角色没有魔族形态，不允许切换到魔族
            if (form === 'mo' && (this.zyCurrentCharacter === 'longqishi' || this.zyCurrentCharacter === 'youxia')) {
                return;
            }
            this.zyCurrentForm = form;
        },
        // 获取当前角色的视频文件
        getCurrentCharacterVideo() {
            // 根据角色名称返回对应的视频文件
            const videoMap = {
                'longqishi': 'longqishivideo.mp4',
                'qishi': 'qishivideo.mp4',
                'fashi': 'nanfashivideo.mp4', // 注意这里使用的是nanfashivideo
                'yemanren': 'yemanrenvideo.mp4',
                'zhanxingshi': 'zhanxingshivideo.mp4',
                'youxia': 'youxiavideo.mp4'
            };

            const videoFileName = videoMap[this.zyCurrentCharacter] || 'longqishivideo.mp4';
            return `https://video.eternaldragoon.com/jpsh/${videoFileName}`;
        },
        // zy页面视频事件处理方法
        onZyVideoLoadStart() {
            this.isZyVideoPlaying = false;
        },
        onZyVideoCanPlay() {
            // 视频可以播放时，稍微延迟一下再隐藏背景，确保视频已经开始渲染
            setTimeout(() => {
                this.isZyVideoPlaying = true;
            }, 100);
        },
        onZyVideoPlaying() {
            this.isZyVideoPlaying = true;
        },
        onZyVideoPause() {
            this.isZyVideoPlaying = false;
        },
        onZyVideoEnded() {
            this.isZyVideoPlaying = false;
        },
        // 显示角色介绍
        showCharacterInfo() {
            if (this.isZyAnimating || this.isZyInfoAnimating || this.showZyCharacterInfo) return;

            // 开始介绍切换动画
            this.isZyInfoAnimating = true;
            this.isZyAnimating = true; // 让视频滑出
            this.isZyVideoPlaying = false;

            // 延迟显示角色介绍，让视频滑出动画完成
            setTimeout(() => {
                this.showZyCharacterInfo = true;
                this.isZyAnimating = false;
                this.isZyInfoAnimating = false;
            }, 500); // 等待滑出动画完成
        },
        // 隐藏角色介绍
        hideCharacterInfo() {
            if (this.isZyInfoAnimating) return;

            this.isZyInfoAnimating = true;

            // 添加滑出动画类
            const infoModal = document.querySelector('.zy-character-info-modal');
            if (infoModal) {
                infoModal.style.animation = 'zy-info-slide-out 0.5s cubic-bezier(0.55, 0.06, 0.68, 0.19) forwards';
            }

            // 延迟隐藏元素和显示视频
            setTimeout(() => {
                this.showZyCharacterInfo = false;
                this.isZyAnimating = true; // 让视频滑入

                // 重新触发视频滑入动画
                this.$nextTick(() => {
                    this.isZyVideoPlaying = true;
                    this.isZyAnimating = false;
                    this.isZyInfoAnimating = false;
                });
            }, 500); // 等待滑出动画完成
        },
        // 获取当前角色图片
        getCharacterImage() {
            // 检查是否有对应的图片
            const character = this.zyCurrentCharacter;
            const form = this.zyCurrentForm;

            // 如果是龙骑士或游侠的魔族形态，返回null（因为没有这些图片）
            if ((character === 'longqishi' || character === 'youxia') && form === 'mo') {
                return null;
            }

            // 构建图片路径
            const imageName = `${character}-${form}`;

            // 使用require方式返回图片路径
            try {
                return require(`@/assets/gw-main/gw-zy/${imageName}.png`);
            } catch (error) {
                console.error(`图片加载失败: ${imageName}.png`, error);
                return null;
            }
        },
        addWheelListener() {
            this._onWheel = (e) => {
                if (this.isScrolling) return;
                this.isScrolling = true;
                setTimeout(() => { this.isScrolling = false; }, 800);
                if (e.deltaY > 0) {
                    this.nextPage();
                } else if (e.deltaY < 0) {
                    this.prevPage();
                }
            };
            this.$el.addEventListener('wheel', this._onWheel, { passive: false });
        },
        removeWheelListener() {
            this.$el.removeEventListener('wheel', this._onWheel);
        },
        nextPage() {
            // 限制最大页面到ts页面（索引4），不能滑动到外链页面
            const maxPage = this.navList.findIndex(item => item.key === 'ts');
            if (this.currentPage < maxPage) {
                this.currentPage++;
                this.swiper.slideTo(this.currentPage);
            }
        },
        prevPage() {
            if (this.currentPage > 0) {
                this.currentPage--;
                this.swiper.slideTo(this.currentPage);
            }
        },
        initSwiper() {
            this.swiper = new Swiper(this.$refs.swiperContainer, {
                direction: 'vertical',
                slidesPerView: 1,
                mousewheel: false,
                on: {
                    slideChange: () => {
                        this.currentPage = this.swiper.activeIndex;
                    },
                },
            });
        },
        openVideoModal() {
            this.showVideoModal = true;
        },
        closeVideoModal() {
            this.showVideoModal = false;
        },
        // 新增ts轮播图方法
        startTsAutoPlay() {
            this.tsTimer = setInterval(() => {
                this.tsCurrentIndex = (this.tsCurrentIndex + 1) % 7;
            }, 3000);
        },
        stopTsAutoPlay() {
            if (this.tsTimer) {
                clearInterval(this.tsTimer);
                this.tsTimer = null;
            }
        },
        goToSlide(idx) {
            this.tsCurrentIndex = idx;
            this.stopTsAutoPlay();
            this.startTsAutoPlay();
        },
        // 初始化Twitter小部件
        initTwitterWidget() {
            console.log('Initializing Twitter widget...');

            // 等待Twitter脚本加载完成
            const checkTwitter = (retryCount = 0) => {
                if (window.twttr && window.twttr.widgets) {
                    console.log('Twitter script loaded, loading widgets...');

                    // 确保容器存在
                    const container = this.$refs.twitterContainer;
                    if (container) {
                        console.log('Twitter container found, loading widgets...');

                        // 清空容器
                        container.innerHTML = '';

                        // 方法1：使用load方法加载现有的timeline
                        window.twttr.widgets.load(container).then(() => {
                            console.log('Twitter widgets loaded successfully');
                        }).catch((error) => {
                            console.error('Error loading Twitter widgets:', error);
                            // 如果加载失败，尝试方法2
                            this.createDirectTimeline(container);
                        });

                        // 设置超时，如果3秒后仍未加载成功，尝试方法2
                        setTimeout(() => {
                            if (container && container.querySelector && container.querySelector('iframe') === null) {
                                console.log('Twitter widget not loaded after 3 seconds, trying direct creation...');
                                this.createDirectTimeline(container);
                            }
                        }, 3000);
                    } else {
                        console.error('Twitter container not found');
                    }
                } else {
                    // 如果Twitter脚本还没加载完成，等待100ms后重试，最多重试50次（5秒）
                    if (retryCount < 50) {
                        setTimeout(() => checkTwitter(retryCount + 1), 100);
                    } else {
                        console.error('Twitter script failed to load after 5 seconds');
                    }
                }
            };
            checkTwitter();
        },

        // 直接创建Twitter时间线的备用方法
        createDirectTimeline(container) {
            if (!window.twttr || !window.twttr.widgets) {
                console.error('Twitter widgets not available');
                return;
            }

            if (!container) {
                console.error('Container is null or undefined');
                return;
            }

            // 清空容器
            container.innerHTML = '';

            // 创建一个新的a标签
            const link = document.createElement('a');
            link.className = 'twitter-timeline';
            link.href = 'https://twitter.com/eternaldragoon_';
            link.setAttribute('data-height', '400');
            link.setAttribute('data-theme', 'light');
            link.setAttribute('data-chrome', 'noheader nofooter noborders transparent');
            link.setAttribute('data-tweet-limit', '5');
            link.textContent = 'Tweets by eternaldragoon_';

            // 添加到容器
            container.appendChild(link);

            // 使用createTimeline方法
            window.twttr.widgets.createTimeline(
                {
                    sourceType: 'profile',
                    screenName: 'eternaldragoon_'
                },
                container,
                {
                    height: 400,
                    theme: 'light',
                    chrome: 'noheader nofooter noborders transparent',
                    tweetLimit: 5
                }
            ).then((el) => {
                if (el) {
                    console.log('Timeline created successfully');
                } else {
                    console.log('Failed to create timeline');
                    // 如果还是失败，尝试加载单个推文
                    this.createSingleTweet(container);
                }
            }).catch((error) => {
                console.error('Error creating timeline:', error);
                // 如果还是失败，尝试加载单个推文
                this.createSingleTweet(container);
            });
        },

        // 创建单个推文的备用方法
        createSingleTweet(container) {
            if (!window.twttr || !window.twttr.widgets) {
                console.error('Twitter widgets not available');
                return;
            }

            if (!container) {
                console.error('Container is null or undefined');
                return;
            }

            // 清空容器
            container.innerHTML = '';

            // 创建一个div来容纳推文
            const tweetDiv = document.createElement('div');
            container.appendChild(tweetDiv);

            // 使用SpaceX的推文ID
            const tweetId = '1732824684683784516'; // SpaceX推文ID

            // 使用createTweet方法
            window.twttr.widgets.createTweet(
                tweetId,
                tweetDiv,
                {
                    theme: 'light',
                    width: 'auto',
                    align: 'center'
                }
            ).then((el) => {
                if (el) {
                    console.log('Tweet created successfully');
                } else {
                    console.log('Failed to create tweet');
                    // 显示一个错误消息
                    container.innerHTML = '<div style="text-align:center;padding:20px;">Twitter content could not be loaded. Please check your connection and try again.</div>';
                }
            }).catch((error) => {
                console.error('Error creating tweet:', error);
                // 显示一个错误消息
                container.innerHTML = '<div style="text-align:center;padding:20px;">Twitter content could not be loaded. Please check your connection and try again.</div>';
            });
        },
    },
    mounted() {
        this.initSwiper();
        this.addWheelListener();
        this.startTsAutoPlay();

        // 延迟初始化Twitter小部件，确保DOM完全渲染
        this.$nextTick(() => {
            setTimeout(() => {
                this.initTwitterWidget();
            }, 1000); // 延迟1秒确保所有资源加载完成
        });
    },
    beforeDestroy() {
        if (this.swiper) this.swiper.destroy();
        this.removeWheelListener();
        this.stopTsAutoPlay();
    },
};
</script>

<style lang="scss" src="./gw-main.scss"></style>